// extracted by mini-css-extract-plugin
export default {"container":"ExchangesPage_container__Gk3qs"};